function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.highlights{fill:#e8dbec;}.white{fill:#fff;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("rect", {
  className: "highlights",
  x: 112,
  y: 104,
  width: 32,
  height: 120
}), React.createElement("path", {
  className: "white",
  d: "M96,40c0,11,14.06,24,24,24s9-9,9-20-8.06-20-18-20S96,29,96,40Z"
}), React.createElement("path", {
  className: "white",
  d: "M129,44c0,11-2.94,20,7,20s24-13,24-24-3.06-16-13-16S129,33,129,44Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("rect", {
  className: "white",
  x: 144,
  y: 104,
  width: 56,
  height: 120
}), React.createElement("rect", {
  className: "highlights",
  x: 116,
  y: -12,
  width: 32,
  height: 200,
  transform: "translate(220 -44) rotate(90)"
}), React.createElement("rect", {
  className: "white",
  x: 56,
  y: 112,
  width: 56,
  height: 120
})), React.createElement("g", {
  id: "primary"
}, React.createElement("rect", {
  className: "primary",
  x: 24,
  y: 64,
  width: 208,
  height: 40
}), React.createElement("rect", {
  className: "primary",
  x: 48,
  y: 104,
  width: 160,
  height: 120
}), React.createElement("path", {
  className: "primary",
  d: "M96,40c0,11,14.06,24,24,24s9-9,9-20-8.06-20-18-20S96,29,96,40Z"
}), React.createElement("path", {
  className: "primary",
  d: "M129,44c0,11-2.94,20,7,20s24-13,24-24-3.06-16-13-16S129,33,129,44Z"
}), React.createElement("line", {
  className: "primary",
  x1: 112,
  y1: 104,
  x2: 112,
  y2: 224
}), React.createElement("line", {
  className: "primary",
  x1: 144,
  y1: 104,
  x2: 144,
  y2: 215.43
})));
var SvgServices = function SvgServices(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Services.df07db46.svg";
export { ForwardRef as ReactComponent };